/**
 * Serializes cart mutations so cart UI updates do not overlap.
 * This keeps Safari from processing several heavy cart morphs at once.
 *
 * @template T
 * @param {() => Promise<T>} task
 * @returns {Promise<T>}
 */
export function enqueueCartMutation(task) {
  const queuedTask = cartMutationChain.catch(() => undefined).then(task);
  cartMutationChain = queuedTask.catch(() => undefined);
  return queuedTask;
}

/** @type {Promise<void>} */
let cartMutationChain = Promise.resolve();
